import React from 'react'
import styled from '@emotion/styled'
import { useRouter } from 'next/router'
import { Header1, Text } from '../../styles/Components'
import { mq } from '../../helpers'
import { gsColors } from '../../styles/Variables'
import Button from '../Button'

const HeaderContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
  justify-content: center;
  padding: 0 100px 0 88px;

  ${mq('max', '1340px')} {
    padding: 0 88px;
  }

  ${mq('max', '1316px')} {
    padding: 0 60px;
  }

  ${mq('max', '1204px')} {
    padding: 0 40px;

    h1 {
      font-size: 46px;
    }

    p {
      font-size: 20px;
    }
  }

  ${mq('max', '1024px')} {
    padding: 0 22px;
  }

  ${mq('max', '909px')} {
    padding: 0 16px;

    h1 {
      font-size: 38px;
    }

    p {
      font-size: 18px;
    }
  }

  ${mq('max', '768px')} {
    height: 400px;
    padding: 44px 16px;
    gap: 8px;

    h1 {
      width: 100% !important;

      .web-only-break {
        display: none;
      }
    }
  }

  ${mq('max', '500px')} {
    h1 {
      font-size: 28px;
    }

    p {
      font-size: 16px;
    }
  }
`

const HeaderContent = () => {
  const router = useRouter()

  const handleClick = () => router.push('/weddings/contact')

  return (
    <HeaderContentWrapper>
      <Header1 color={gsColors.salmon} className="hero-title">
        WEDDING {' '}
        <br className='web-only-break'/>
        {/* <br />*/}
        HAIR + MAKEUP,
        <br />
        DELIVERED.
      </Header1>
      <Text
        className="hero-content"
        fontSize={22}
        color={gsColors.white}
        lineHeight="138%"
      >
        Your big day is a big deal. With Glamsquad, you can feel confident
        knowing our team of bridal-certified beauty pros will bring your dream
        look to life.
      </Text>
      <Button
        onClick={handleClick}
        large
        color={gsColors.salmon}
        style={{ color: gsColors.cobalt }}
      >
        Get in Touch
      </Button>
    </HeaderContentWrapper>
  )
}

export default HeaderContent
